export default `
  fragment Measurement  on DisplayMeasurement {
    dimension
    unit
  }
`;
